import React, {PropsWithChildren, useMemo} from "react";
import {isMessageError, isNetworkError} from "@firefly/fly-http";
import {QueryClient, QueryClientProvider} from "react-query";



export default function AppQueryClientProvider({children}: PropsWithChildren<any>) {

    function showError(result: any) {

    }

    const queryClient = useMemo(() => {
        function onError(error: any) {
            if (isMessageError(error)) {
                const {
                    message,
                    errorInfo,
                    request,
                    response,
                } = error;
                const title = message;
                const subTitle = errorInfo ? `错误代码： ${errorInfo.code}` : undefined;
                showError({
                    title: title,
                    subtitle: subTitle,
                    details: [
                        response && {
                            key: "X-TraceID",
                            value: response.headers.get("X-TraceID"),
                        },
                        response && {
                            key: "Method",
                            value: request.method,
                        },
                        request && {
                            key: "URL",
                            value: request.url,
                        }
                    ].filter(item => item)
                })
            } else if (isNetworkError(error)) {
                showError({
                    title: error.message??"网络错误"
                })
            } else if (typeof error === 'string'){
                showError({
                    title: error as string,
                })
            } else {
                showError({
                    title: "无法识别错误",
                })
            }
        }
        return new QueryClient({
            defaultOptions: {
                queries: {
                    refetchOnWindowFocus: false,
                    retry: false,
                    onError: onError,
                },
                mutations: {
                    onError: onError,
                }
            }
        })
    }, []);

    return (
        <QueryClientProvider client={queryClient}>
            {children}
        </QueryClientProvider>
    )
}
